import { Expose } from 'class-transformer';

import { SnModel } from '@lib/common/models';

import { IFsLprQueryResultInterface } from '../interfaces/lpr-query-result.interface';

export class LprReadModel extends SnModel {
  @Expose()
  public item: IFsLprQueryResultInterface;

  constructor(data: any = {}) {
    super();
    this.fromJSON(data);
  }
}
